import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyArZF--MhaLOUXDSMxZl9KrShPArQsDuaU",
  authDomain: "myproxy1-com.firebaseapp.com",
  projectId: "myproxy1-com",
  storageBucket: "myproxy1-com.firebasestorage.app",
  messagingSenderId: "735537758844",
  appId: "1:735537758844:web:5dd5b4863d49ea13ecfff9",
  measurementId: "G-G4X55PM9J5"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics }; 